import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { pitcherReducer } from 'src/features/atoms/glove/japan/slice/pitcher'
import { useLocale } from 'src/locales/useLocale'
import { useRouter } from 'next/router'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'

const AtomsPitcher: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const models = atomsBaseModel(t, router)
  const [state, dispatch] = React.useReducer(pitcherReducer, t.INITIAL_STATE_PITCHER)
  const [figurePanelNum, setFigurePanelNum] = React.useState(1)
  const handleFigurePanelNum = (_, newValue: number) => setFigurePanelNum(newValue)
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.SOFT} / ATOMS / ${t.PITCHER}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} kinds={{ label: '軟式', value: 'soft' }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsPitcher
